<template>
  <div id="picker" @click="cancelEvent">
    <div id="picker-view" >

      <div class="picker-view-header">
        <div class="picker-view-lable picker-view-lable-cancel" @click="cancelEvent">取消</div>
        <div class="picker-view-lable picker-view-lable-commit" @click="commitEvent">确认</div>
      </div>
      <div class="picker-wrapper">
        <mt-picker :slots="dataSlots"  valueKey = 'value'   @change="onValuesChange" ></mt-picker>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState,mapGetters } from 'vuex'

  export default {
    data(){
      return {
        pickerArea:'',
        curPro:'',
        curCity: '',
        dataSlots:[
          {
            flex: 1,
            values: [],
            className: 'slot1',
            textAlign: 'right'
          }, {
            divider: true,
            content: '-',
            className: 'slot2'
          }, {
            flex: 1,
            values: [],
            className: 'slot3',
            textAlign: 'left'
          }
        ]
      }

    },
    computed: {
      ...mapState({
        provinceList: state=>state.addressSelect.provinceList,
        cityList: state=>state.addressSelect.cityList,
      }),
    },
    watch:{
      curPro(val,oldValue){
          let self = this;
          this.$nextTick(function(){
            val&&self.$store.dispatch('getOriginCity',{'provinceId':val})
          })
      },
      cityList(val,oldValue){
        if(val !== oldValue){
          this.dataSlots[2].values = val;
        }
      },
      provinceList(val,oldValue){
        if(val !== oldValue){
          this.dataSlots[0].values = val;
        }
      }
    },
    methods: {
      cancelEvent () {
        var eventObj = {}
        this.$emit('picker-event', eventObj);
      },
      commitEvent () {
        const { pickerArea,curPro,curCity} = this;
        let eventObj = {
          selectData: pickerArea,
          addressProvince : curPro,
          addressCity : curCity
        }
        this.$emit('picker-event', eventObj);
      },
      getProvince(){
        let self = this;
        this.$store.dispatch('getOriginProvince').then(function(){
          const { provinceList } = self;
          self.dataSlots[0].values = provinceList
        });
      },
      onValuesChange(picker, values){
        let self = this;
        this.$nextTick(function(){
          self.curPro = values[0] ?  values[0].key : '';
          self.curCity = values[1] ?  values[1].key : '';
          self.pickerArea = values[1] ? values[0].value +' '+ values[1].value : '';
        })
        
      }
    },
    mounted () {
      this.getProvince()
    }
  }
</script>

<style lang="scss">
  @import '../../../assets/css/mixin';


  #picker {
    background: rgba(25,25,25,0.30);
    position: fixed;
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
    z-index: 666;
  }
  #picker-view {
    position: absolute;
    height: pxToRem(470px);
    background-color: #EEEEEE;
    bottom: 0px;
    left: 0px;
    right: 0px;
  }
  #picker-wrapper {
    bottom: 0px;
    top: pxToRem(100px);
    background-color: #EEEEEE;
  }
  .picker-view-header {
    height: pxToRem(100px);
    background-color: white;
    left: 0;
    right: 0;
    top: 0;

  }
  .picker-center-highlight:before, .picker-center-highlight:after {
    background-color: #BDBDBD;
  }
  .picker-items {
    background-color: #EEEEEE;
  }
  .picker-view-lable {
    color: #191919;
    font-size: pxToRem(24px);
    height: pxToRem(100px);
    line-height: pxToRem(100px);
    display: inline-block;
  }
  .picker-view-lable-commit {
    margin-left: pxToRem(576px);
  }
  .picker-view-lable-cancel {
    margin-left: pxToRem(40px);
  }


</style>


// WEBPACK FOOTER //
// cityPicker.vue?4c2aa429